<div class="main-dialog">

    <div class="dialog-header">
        <div class="header-title">
			<span style="font-size: 120%;"><span style="margin-right: 0.25em;">
					Transactions {{userName}}
                {{startDate | date: 'MMM d, y'}} - {{finishDate | date: 'MMM d, y'}}
				</span>
			</span>
        </div>

        <div style="flex: 1">

        </div>

        <button mat-button class="close-button-container" mat-dialog-close disableRipple="true">
            <mat-icon>clear</mat-icon>
        </button>
    </div>

    <div class="adds-info-block">
        <div class="name-blocck">
            <div class="name-title">
                {{userName}}
            </div>
        </div>
        <div class="total-overdue-block">
            <div class="pmnt est-pmnt" [ngClass]="{'line-hided': !Estimate}" (click)="toggleType('Estimate')">
				<span class="pmnt-span">
					${{totalInfo?.totalAmt | number:'1.2-2'}}
				</span>
                <span class="pmnt-title">
					Estimates
				</span>
            </div>
            <div class="pmnt inv-pmnt" [ngClass]="{'line-hided': !Invoice}" (click)="toggleType('Invoice')">
				<span class="pmnt-span">
					${{totalInfo?.invoicedBalance | number:'1.2-2'}}
				</span>
                <span class="pmnt-title">
					Invoiced
				</span>
            </div>
            <div class="pmnt pmnt-pmnt" [ngClass]="{'line-hided': !Payment}" (click)="toggleType('Payment')">
				<span class="pmnt-span">
					${{totalInfo?.paymentsReceived | number:'1.2-2'}}
				</span>
                <span class="pmnt-title">
					Payments
				</span>
            </div>
            <div class="pmnt bill-pmnt" *ngIf="totalInfo?.unBilledAmount > 0">
				<span class="pmnt-span">
					${{totalInfo?.unBilledAmount | number:'1.2-2'}}
				</span>
                <span class="pmnt-title">
					Unbilled
				</span>
            </div>
        </div>
    </div>

    <div class="middle-content">
        <div class="header-order">
            <div class="date-block label-block">
                <div class="label-name" (click)="sortByLabel('createTime')" matRipple>DATE
                    <i *ngIf="sortMap.get('createTime') === 1" class="pi pi-arrow-down"></i>
                    <i *ngIf="sortMap.get('createTime') === 2" class="pi pi-arrow-up"></i>
                </div>
            </div>
            <div class="balance-block label-block">
                <div class="label-name" (click)="sortByLabel('type')" matRipple>TYPE
                    <i *ngIf="sortMap.get('type') === 1" class="pi pi-arrow-down"></i>
                    <i *ngIf="sortMap.get('type') === 2" class="pi pi-arrow-up"></i>
                </div>
            </div>
            <!-- <div class="nom-block label-block">
                <div class="label-name" (click)="sortByLabel('docNumber')" matRipple>NO.
                    <i *ngIf="sortMap.get('docNumber') === 1" class="pi pi-arrow-down"></i>
                    <i *ngIf="sortMap.get('docNumber') === 2" class="pi pi-arrow-up"></i>
                </div>
            </div> -->
            <div class="balance-block label-block">
                <div class="label-name" (click)="sortByLabel('balance')" matRipple>BALANCE
                    <i *ngIf="sortMap.get('balance') === 1" class="pi pi-arrow-down"></i>
                    <i *ngIf="sortMap.get('balance') === 2" class="pi pi-arrow-up"></i>
                </div>
            </div>
            <div class="total-block label-block">
                <div class="label-name" (click)="sortByLabel('totalAmt')" matRipple>TOTAL
                    <i *ngIf="sortMap.get('totalAmt') === 1" class="pi pi-arrow-down"></i>
                    <i *ngIf="sortMap.get('totalAmt') === 2" class="pi pi-arrow-up"></i>
                </div>
            </div>
            <div class="project-block label-block">
                <div class="label-name" (click)="sortByLabel('jobName')" matRipple>Job Name
                    <i *ngIf="sortMap.get('jobName') === 1" class="pi pi-arrow-down"></i>
                    <i *ngIf="sortMap.get('jobName') === 2" class="pi pi-arrow-up"></i>
                </div>
            </div>
            <div class="status-block label-block">
                <div class="label-name" (click)="sortByLabel('txnStatus')" matRipple>STATUS
                    <i *ngIf="sortMap.get('txnStatus') === 1" class="pi pi-arrow-down"></i>
                    <i *ngIf="sortMap.get('txnStatus') === 2" class="pi pi-arrow-up"></i>
                </div>
            </div>
            <div class="link-block">
            </div>
        </div>

        <div class="transaction-lines">

            <div class="transaction-line"
                 *ngFor="let transaction of userTransactions; index as i; trackBy: trackEntityById">

                <div class="date-block label-block">
                    <div class="label-name">{{transaction.txnDate | date: 'M/d/yy'}}</div>
                </div>
                <div class="type-block label-block">
                    <div class="label-name">{{transaction.type}}</div>
                </div>
                <!-- <div class="nom-block label-block">
                    <div class="label-name">{{transaction.qbId}}</div>
                </div> -->
                <div class="balance-block label-block">
                    <div class="label-name">{{transaction.balance | number:'1.2-2'}}</div>
                </div>
                <div class="total-block label-block" [ngClass]="{'has-project': transaction.project}">
                    <div class="label-name" (click)="openBilling(transaction.project)">
                        {{transaction.totalAmt | number:'1.2-2'}}</div>
                </div>
                <div class="JOB-block label-block">
                    <div class="label-name" (click)="openProject(transaction.project?.id)">{{transaction.project?.name}}
                    </div>
                </div>
                <div class="status-block label-block">
                    <div class="label-name">{{transaction.txnStatus}}</div>
                </div>
                <div class="link-block">
                    <button mat-button class="open-link-button" (click)="openInQb(transaction)">
                        <mat-icon>open_in_new</mat-icon>
                    </button>
                </div>
            </div>

        </div>

        <div class="spinner-box" *ngIf="contentLoading">
            <mat-spinner class="spinner"></mat-spinner>
        </div>

    </div>

</div>
